import React from 'react';
import { FMButton } from '@own/fds-react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';

interface RecallsSignInProps {
    recallsSignInProps: RecallsUnitedContent;
    localStorageUserName: string | null | undefined;
    recallsAuthentication: () => void;
}

export const RecallSignIn = (props: RecallsSignInProps) => {
    const recallSignInMessage = props.localStorageUserName
        ? props.recallsSignInProps.signInTitleWithUsername.replace(
              '##CustomerName##',
              props.localStorageUserName
          )
        : props.recallsSignInProps.signInTitleWithoutUsername;

    return (
        <div className={`recalls-sign-in-section`} data-testid="recall-sign-in">
            {props.recallsSignInProps.signInTitleWithUsername &&
                props.recallsSignInProps.signInTitleWithoutUsername && (
                    <div className="sign-in-title">{recallSignInMessage}</div>
                )}
            {props.recallsSignInProps.signInDescription && (
                <div className="sign-in-description">
                    {props.recallsSignInProps.signInDescription}
                </div>
            )}
            {props.recallsSignInProps.signInCtaLabel && (
                <div className="sign-in-cta">
                    <FMButton
                        type={
                            props.localStorageUserName ? 'primary' : 'secondary'
                        }
                        label={props.recallsSignInProps.signInCtaLabel}
                        onClick={() => {
                            props.recallsAuthentication();
                        }}
                    />
                </div>
            )}
        </div>
    );
};
